import React from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Card, Form } from 'antd';
import Top from './Top';
import Right from './Right';

const createForm = Form.create;
const store = [
  'devStore'
]
@inject(...store)
@observer
class Main extends React.Component {
  static defaultProps = {
    lastPrefixCls: 'dev',
    prefixCls: 'dev-apply',
    formRequiredClass: 'dev-form-required',
  }
  componentDidMount() {
    const { form, devStore: { getGenre, setMobxState, getDevAppDetail, updateForm }, location } = this.props;
    const pathname = location.pathname;
    getGenre();
    getGenre({ type: 'n' });
    if (pathname !== 'dev/apply') {
      setMobxState({
        currentStatus: 1,
      });
      getDevAppDetail({ s_id: pathname.slice(pathname.indexOf('/') + 1, pathname.lastIndexOf('/')) }).then((data) => {
        const { app, license } = data;
        setMobxState({
          currentStatus: app.s_status <= 1 ? 1 : app.s_status,
          appType: app.realNumber && app.realNumber.length === 33 ? 2 : 1,
        });
        //延时 确保form field渲染后 updateForm
        setTimeout(() => {
          updateForm(form, {
            ...app,
            c_name: license.dl_cname,
            license: license.dl_license,
          }, 0);
        }, 300);
      });
    }
  }
  componentWillUnmount() {
    const { form } = this.props;
    form.resetFields();
  }
  render() {
    const {
      lastPrefixCls, prefixCls, formRequiredClass, form,
      devStore: { appType, setMobxState, initForm },
    } = this.props;
    return (
      <div className={`${prefixCls}`}>
        <Row>
          <Col span={18}>
            <div className={`${lastPrefixCls}-left`}>
              {
                appType === 0 ? (<div className={`${prefixCls}-card`}>
                  <Card
                    title="服务端应用"
                    extra={(
                      <a onClick={() => {
                        setMobxState({ appType: 1 }); initForm();
                      }}>创建</a>
                    )}>
                    开发者通过服务端(本系统)创建应用，生成应用编号供开发、发布使用
                  </Card>
                  {/* <Card
                    title="客户端应用"
                    extra={(
                      <a onClick={() => {
                        setMobxState({ appType: 2 }); initForm();
                      }}>创建</a>
                    )}>
                    开发者已在客户端(ecology中的云商店)创建应用，在此将应用发布到服务端(本系统)
                  </Card> */}
                </div>) : (<Top form={form} formRequiredClass={formRequiredClass} onChange={this.onChange} />)
              }
            </div>
          </Col>
          <Col span={6}>
            <div className={`${lastPrefixCls}-right`}>
              <Right form={form} formRequiredClass={formRequiredClass} onChange={this.onChange} />
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

Main = createForm()(Main);
export default Main;


// WEBPACK FOOTER //
// ./src/components/dev/devApply/index.js